export const lerp = (a, b, n) => (1 - n) * a + n * b
